const AuthRouter = {
  path: "/auth",
  abstract: true,
  replace: true,
  component: () => import("@/components/auth/containers/AuthScreen"),

  children: [
    {
      path: "",
      alias: "signin",
      component: () => import("@/components/auth/containers/SignIn"),
    },
    {
      path: "register",
      component: () => import("@/components/auth/containers/SignUp"),
    },
  ],
};

export default AuthRouter;
